import React, { ReactNode } from 'react';
import { connect } from 'react-redux';

import { pushFlashMessage } from 'store/main/ducks/flashMessages';
import {
  hideListing as hideVolop,
  unhideListing as unhideVolop,
} from 'store/main/ducks/groupDashboard/listings';

type OwnProps = {
  volopId: string;
  groupId: string;
  render: (arg0: {
    hideVolop: () => void;
    unhideVolop: () => void;
    submitting: boolean;
  }) => ReactNode;
};
type Props = OwnProps & {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hideVolop: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unhideVolop: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pushFlashMessage: (...args: Array<any>) => any;
};
type State = {
  submitting: boolean;
};
class HideGroupVolopContainer extends React.PureComponent<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    submitting: false,
  };

  hideVolop = () => {
    this.setState({
      submitting: true,
    });
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    return this.props
      .hideVolop({
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        groupId: this.props.groupId,
        listingType: 'VOLOP',
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        listingId: this.props.volopId,
      })
      .then(() => {
        this.setState({
          submitting: false,
        });
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.pushFlashMessage({
          type: 'LISTING_HIDDEN',
        });
      });
  };

  unhideVolop = () => {
    this.setState({
      submitting: true,
    });
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    return this.props
      .unhideVolop({
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        groupId: this.props.groupId,
        listingType: 'VOLOP',
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        listingId: this.props.volopId,
      })
      .then(() => {
        this.setState({
          submitting: false,
        });
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.pushFlashMessage({
          type: 'LISTING_UNHIDDEN',
        });
      });
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.render({
      hideVolop: this.hideVolop,
      unhideVolop: this.unhideVolop,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      submitting: this.state.submitting,
    });
  }
}

// @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
export default connect<Props, OwnProps, _, _, _, _>(null, {
  hideVolop,
  unhideVolop,
  pushFlashMessage,
})(HideGroupVolopContainer);
